import { KYC_STATUSES } from '@shinetools/kyc-validation';

import { VerificationStepStatus } from 'features/Onboarding/legacy/components/VerificationStep/types';

const getKycStepStatus = (
  kycStatus: keyof typeof KYC_STATUSES,
): VerificationStepStatus => {
  switch (kycStatus) {
    case 'NONE':
      return 'waiting';
    // TODO(matt): Display a different message for documents in MISSING status
    case 'MISSING':
      return 'waiting';
    case 'REFUSED':
      return 'error';
    case 'VALIDATED':
      return 'complete';
    default:
      return 'pending';
  }
};

export default getKycStepStatus;
